<template>
  <EFooterCard
    :title="$t(`common.footer.card.blog.title`)"
    :button-text="$t(`common.footer.card.blog.button`)"
    :button-link="buttonLink"
    data-track-id="main-footer-card"
    data-track-property="find_out_where_we_plant_trees"
    :data-track-value="position"
  >
    <template #illustrations>
      <div class="main-footer-blog-card__illustration">
        <EIllustration aria-hidden="true" />
      </div>
    </template>
  </EFooterCard>
</template>

<script>
import { mapState } from 'vuex';

import { getBlogURL } from '~~/common/js/universal/url-utils';
import EFooterCard from '~~/common/vue/components/footer-card';
import EIllustration from '~~/common/vue/assets/images/footer-card-illustration.svg';

export default {
  name: 'EMainFooterBlogCard',
  components: {
    EFooterCard,
    EIllustration,
  },
  props: {
    position: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('global', ['locale']),
    buttonLink() {
      return getBlogURL(this.locale);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-footer-blog-card__illustration {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  margin: $space-m;

  & > svg {
    width: 100%;
    height: 100%;
  }
}
</style>
